import React, { FunctionComponent } from 'react'
import QuizzLogo from './QuizzLogo'
import { tt } from '../../../i18n'
import FlexPicture from '../../../components/FlexPicture'
import TripAdvisorButton from '../../../components/TripAdvisorButton'
import WheelButton from '../../../components/cta/WheelButton'
import { lotteryConfigSelector } from '../../../redux/selectors/lottery'
import { useDispatch, useSelector } from 'react-redux'
import { goToEnd } from '../../../redux/actions/quizz'

interface Props {
  finalPlaceName: string
}

const QuizzTripAdvisor: FunctionComponent<Props> = ({ finalPlaceName }) => {
  const lotteryConfig = useSelector(lotteryConfigSelector)

  const dispatch = useDispatch()

  return (
    <>
      <QuizzLogo containerClass={'logo-container-centered'} useConfig={true} />
      <div className="w-margin-bottom-third">
        <h2 className="h2 text-center">
          {tt('redeem_h1_tripadvisor', {
            finalPlaceName: finalPlaceName,
          })}
        </h2>
      </div>
      <div className="w-margin-bottom-third">
        <div className="col s12">
          <p className="text-center">{tt('redeem_text_tripadvisor')}</p>
        </div>
      </div>
      <FlexPicture
        isModal={false}
        src={undefined}
        dataSrc="image:/cdm/hearts.png"
        marginH={Math.trunc(window.innerWidth * 0.05)}
        marginV={Math.trunc(window.innerHeight * 0.05)}
        heightPc={0.5}
      />
      <div className="bottom-after-wheel cm-pad w-padding-bottom">
        <div className="w-margin-bottom-third text-center">
          <TripAdvisorButton
            disableClick={true}
            step={undefined}
            text={tt('quizz_trip_advisor')}
            link={lotteryConfig?.tripAdvisorLink}
            onClick={dispatch(goToEnd)}
            preventNextStep={true}
          />
          <div style={{ marginTop: 10 }}>
            <WheelButton
              id="k-go-to-gift"
              text={tt('choose_my_gift')}
              isInverted={true}
              onClick={dispatch(goToEnd)}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default QuizzTripAdvisor
